// extracted by mini-css-extract-plugin
module.exports = {"videoOverlay":"VideoAnimation_videoOverlay__2z71M","loaded":"VideoAnimation_loaded__QnBpN","overlayText":"VideoAnimation_overlayText__2YTgQ","video":"VideoAnimation_video__2A-8Q"};